import Search from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Checkbox,
  TextField as MuiTextField,
} from "@mui/material";

export type MultiSelectFilterPickerOption = {
  id: string;
  name: string;
};

export type MultiSelectFilterPickerProps = {
  /** The available options to select from */
  options: MultiSelectFilterPickerOption[];
  /** The currently selected options */
  value: MultiSelectFilterPickerOption[];
  /** Callback when the selection changes */
  onChange: (selected: MultiSelectFilterPickerOption[]) => void;
  /** Whether the picker is disabled */
  disabled?: boolean;
  /** Label for the field */
  label: string;
  /** Test ID for the component */
  testId?: string;
};

export function MultiSelectFilterPicker({
  options,
  value,
  onChange,
  disabled = false,
  label,
  testId = "multiSelectFilterPicker",
}: MultiSelectFilterPickerProps) {
  return (
    <Box data-testid={testId}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        disabled={disabled}
        options={options}
        value={value}
        onChange={(_e, newValue) => onChange(newValue)}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        renderOption={(props, option, { selected }) => {
          const { key, ...listItemProps } = props;
          return (
            <li key={key} {...listItemProps}>
              <Checkbox checked={selected} sx={{ mr: 1 }} />
              {option.name}
            </li>
          );
        }}
        renderInput={(params) => (
          <MuiTextField
            {...params}
            label={label}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <Search fontSize="medium" color="primary" />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
}
